<template>
    <div class="container">
        <iframe :src="src" width="100%" :height="height" frameborder="0"> </iframe>
    </div>
</template>
<script>
export default {
    props: ["labels", "dataset", "opciones"],
    data: () => ({
        height: 500,
        src: "",
    }),
    mounted() {
        this.src = this.dataset.datos;
        this.height = this.dataset.etiqueta;
    },
};
</script>
